import { FC, PropsWithChildren } from "react";
import { Box } from "@mui/material";
import { ProgressOverlay } from "@framework/mui-page-layout";
import { StyledContainer, StyledContent, StyledHeader, StyledTitle } from "./styled";

interface IOpenableWindow {
  title: string;
  componentName: string;
  isLoading?: boolean;
}

export const OpenableWindow: FC<PropsWithChildren<IOpenableWindow>> = props => {
  const { children, title, isLoading } = props;

  return (
    <Box
      sx={{
        m: 0,
        width: "100%",
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ProgressOverlay
        isLoading={!!isLoading}
        wrapperSx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <StyledContainer>
          <StyledHeader sx={{ display: "flex", justifyContent: "space-between" }}>
            <StyledTitle>{title}</StyledTitle>
          </StyledHeader>
          <StyledContent sx={{ overflow: "hidden" }}>{children}</StyledContent>
        </StyledContainer>
      </ProgressOverlay>
    </Box>
  );
};
